<template>
  <div class="recentActivity-main">
    <div class="title">
      {{ $t('Recent Activity') }}
    </div>

    <div v-loading="loading"
         class="recentActivity-main-box">
      <div v-for="(item, index) in recentActivityData"
           :key="index"
           class="social-card">
        <router-link
          :to="{ name: Breadcrumbs.imagesetDetail ,params: { visitId: item.image_set[0].visit_id ,
                                                             imagesetId: item.image_set[0].id,
                                                             socialModalStatus: true } }">
          <div class="content_img">
            <img class="social-card-img"
                 :src="item.file_url"
                 width="69px"
                 height="96px">
            <div class="hover-title">
              {{ $t('VIEW IMAGESET') }}
            </div>
          </div>
        </router-link>

        <div class="social-card-infoBox">
          <div class="storeName">
            {{ item.store[0].display_name }}
          </div>

          <div class="social-card-comment">
            <div class="social-card-email">
              <i v-if="item.action_type === 'Comment'" class="mdi mdi-comment social-icons" />
              <i v-else-if="item.action_type === 'Like'" class="mdi mdi-thumb-up social-icons" />
              <span> {{ item.user[0].email }} </span>
            </div>

            <div v-if="item.action_type === 'Like'">
              {{ $t('liked your imageset') }}
            </div>

            <div v-if="item.content !== null">
              {{ item.content }}
            </div>

            <div class="social-card-time">
              {{ chatDate(item.created_at) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import i18n from '@/i18n';
import { fetchRecentActivity } from '../api';

export default {
  name: 'RecentActivity',
  props: {
    projectId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      recentActivityData: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { projectId } = this;

      try {
        this.loading = true;
        const { data: { data } } = await fetchRecentActivity(projectId);
        this.recentActivityData = data;
      } catch (err) {
        console.warn(err);
      }
      this.loading = false;
    },
    chatDate(date) {
      moment.locale(i18n.locale);
      const startDate = moment().startOf().format('DD/MM/YYYY');
      const endDate = moment(date).format('DD/MM/YYYY');

      if (startDate === endDate) {
        return moment(date).fromNow();
      }

      return moment(date).format('DD/MM/YYYY');
    }
  }

};
</script>

<style lang="scss">
.recentActivity-main {
  width: 100%;
  min-width: 320px;
  padding: 20px 0 13px 20px;
  background-color: $white;
  border-radius: 3px;

  .title {
    padding-bottom: 20px;
    font-weight: 700;
  }
}

.recentActivity-main-box {
  width: 100%;
  height: 735px; // can't use max-height, because v-loading needs a height property.
  overflow-x: hidden;
  overflow-y: scroll;
}

.social-card {
  display: flex;
  margin-bottom: 15px;

  .content_img {
    position: relative;
  }

  .content_img .hover-title {
    position: absolute;
    top: 5px;
    left: 0;
    margin-bottom: 5px;
    font-family: sans-serif;
    font-size: 8px;
    color: white;
    text-align: center;
    visibility: hidden;
    background: $darkSkyBlue;
    opacity: 0;
    -webkit-transition: visibility 0s, opacity 0.5s linear;
    transition: visibility 0s, opacity 0.5s linear;
  }

  .content_img:hover .hover-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 69px;
    height: 96px;
    visibility: visible;
    opacity: 0.8;
  }

  .social-card-time {
    font-size: 14px;
    font-weight: 600;
    color: #656b7d;
  }

  .social-card-email {
    display: flex;
    width: 220px;
    font-size: 14px;
    font-weight: bold;
  }

  .storeName {
    font-size: 15px;
    font-weight: bold;
  }

  .social-icons {
    margin-right: 5px;
    font-size: 17px;
    color: gray;
  }

  .social-card-img {
    padding: 5px 20px 20px 0;
  }

  .social-card-infoBox {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
}

@include breakpoint(md-max) {
  .recentActivity-main {
    width: unset;
    padding: 20px;
  }

  .recentActivity-main-box {
    max-height: 400px;
  }
}
</style>
